var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScanTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 456,
    viewBox: "0 0 456 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.447 63.6196C253.817 76.9348 242.083 86.9744 228 86.9744C213.917 86.9744 202.183 76.9348 199.553 63.6196H130.203V392.373H199.553C202.183 379.058 213.917 369.018 228 369.018C242.083 369.018 253.817 379.058 256.447 392.373H325.789V63.6196H256.447Z",
    fill: "#136EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.15 383.26C257.306 369.375 243.55 359.906 228.008 359.906C212.466 359.906 198.702 369.368 192.865 383.26H139.338V72.7396H192.865C198.71 86.6248 212.466 96.0944 228.008 96.0944C243.55 96.0944 257.313 86.6324 263.15 72.7396H316.669V383.253H263.15V383.26Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.331 298.809V383.26H192.858C198.702 369.375 212.458 359.906 228 359.906C243.542 359.906 257.306 369.368 263.142 383.26H316.662V298.809H139.323H139.331Z",
    fill: "#C4DBFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.331 383.26H192.858C198.702 369.375 212.458 359.906 228 359.906C243.542 359.906 257.306 369.368 263.142 383.26H316.662V298.809L139.323 383.26H139.331Z",
    fill: "#89B6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.669 299.569H311.683V298.049H316.669V299.569ZM306.614 299.569H301.545V298.049H306.614V299.569ZM296.476 299.569H291.407V298.049H296.476V299.569ZM286.337 299.569H281.268V298.049H286.337V299.569ZM276.199 299.569H271.13V298.049H276.199V299.569ZM266.061 299.569H260.991V298.049H266.061V299.569ZM255.922 299.569H250.853V298.049H255.922V299.569ZM245.784 299.569H240.715V298.049H245.784V299.569ZM235.645 299.569H230.576V298.049H235.645V299.569ZM225.507 299.569H220.438V298.049H225.507V299.569ZM215.369 299.569H210.299V298.049H215.369V299.569ZM205.23 299.569H200.161V298.049H205.23V299.569ZM195.092 299.569H190.023V298.049H195.092V299.569ZM184.953 299.569H179.884V298.049H184.953V299.569ZM174.815 299.569H169.746V298.049H174.815V299.569ZM164.677 299.569H159.607V298.049H164.677V299.569ZM154.538 299.569H149.469V298.049H154.538V299.569ZM144.4 299.569H139.331V298.049H144.4V299.569Z",
    fill: "#136EF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3544 164.639H68.3848V166.159H87.3544V164.639Z",
    fill: "#555E6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6294 155.922H77.1094V174.891H78.6294V155.922Z",
    fill: "#555E6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M374.467 111.621H355.498V113.141H374.467V111.621Z",
    fill: "#555E6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M365.742 102.896H364.222V121.866H365.742V102.896Z",
    fill: "#555E6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0205 131.161C96.2465 131.161 93.9893 128.904 93.9893 126.13C93.9893 123.356 96.2465 121.098 99.0205 121.098C101.794 121.098 104.052 123.356 104.052 126.13C104.052 128.904 101.794 131.161 99.0205 131.161ZM99.0205 122.618C97.0825 122.618 95.5093 124.192 95.5093 126.13C95.5093 128.068 97.0825 129.641 99.0205 129.641C100.958 129.641 102.532 128.068 102.532 126.13C102.532 124.192 100.958 122.618 99.0205 122.618Z",
    fill: "#555E6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M364.982 160.953C362.208 160.953 359.951 158.696 359.951 155.922C359.951 153.148 362.208 150.89 364.982 150.89C367.756 150.89 370.014 153.148 370.014 155.922C370.014 158.696 367.756 160.953 364.982 160.953ZM364.982 152.41C363.044 152.41 361.471 153.984 361.471 155.922C361.471 157.86 363.044 159.433 364.982 159.433C366.92 159.433 368.494 157.86 368.494 155.922C368.494 153.984 366.92 152.41 364.982 152.41Z",
    fill: "#555E6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0205 91.7776C96.2465 91.7776 93.9893 89.5204 93.9893 86.7464C93.9893 83.9724 96.2465 81.7152 99.0205 81.7152C101.794 81.7152 104.052 83.9724 104.052 86.7464C104.052 89.5204 101.794 91.7776 99.0205 91.7776ZM99.0205 83.2352C97.0825 83.2352 95.5093 84.8084 95.5093 86.7464C95.5093 88.6844 97.0825 90.2576 99.0205 90.2576C100.958 90.2576 102.532 88.6844 102.532 86.7464C102.532 84.8084 100.958 83.2352 99.0205 83.2352Z",
    fill: "#555E6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.373 151.354H187.104V166.622H202.373V151.354Z",
    fill: "#1D2939"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 175.682H226.761V190.95H242.03V175.682Z",
    fill: "#1D2939"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.747 150.503H261.136V159.114H269.747V150.503Z",
    fill: "#1D2939"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.357 141.892H269.747V150.503H278.357V141.892Z",
    fill: "#1D2939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.41 172.49H256.044V177.855H261.41V172.49Z",
    fill: "#1D2939"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.402 143.572H254.896V150.503H261.402V143.572Z",
    fill: "#1D2939"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226.761 190.95H221.396V196.316H226.761V190.95Z",
    fill: "#1D2939"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192.052 185.987H186.687V191.353H192.052V185.987Z",
    fill: "#1D2939"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M276.739 190.95H271.373V196.316H276.739V190.95Z",
    fill: "#1D2939"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.587 190.95H252.221V196.316H257.587V190.95Z",
    fill: "#1D2939"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M214.115 178.364H175.362V139.612H214.115V178.364ZM179.922 173.804H209.555V144.172H179.922V173.804Z",
    fill: "#1D2939"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.637 196.316H276.077V144.172H222.125V139.612H280.637V196.316Z",
    fill: "#1D2939"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M265.794 164.342H211.834V168.902H265.794V164.342Z",
    fill: "#1D2939"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M252.525 166.622H247.965V196.316H252.525V166.622Z",
    fill: "#1D2939"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M278.358 181.435H250.245V185.995H278.358V181.435Z",
    fill: "#1D2939"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250.237 152.889H222.125V157.449H250.237V152.889Z",
    fill: "#1D2939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.922 183.715H175.362V196.316H179.922V183.715Z",
    fill: "#1D2939"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.922 203.475H175.362V260.368H179.922V203.475Z",
    fill: "#1D2939"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.649 203.475H187.089V260.368H191.649V203.475Z",
    fill: "#1D2939"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M203.376 203.475H198.816V260.368H203.376V203.475Z",
    fill: "#1D2939"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.525 203.475H247.965V260.368H252.525V203.475Z",
    fill: "#1D2939"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M280.638 203.475H276.078V260.368H280.638V203.475Z",
    fill: "#1D2939"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.145 203.475H212.025V260.368H221.145V203.475Z",
    fill: "#1D2939"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M268.857 203.475H259.737V260.368H268.857V203.475Z",
    fill: "#1D2939"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M241.999 203.475H226.799V260.368H241.999V203.475Z",
    fill: "#1D2939"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M203.376 196.316H198.816V183.008H213.4V187.568H203.376V196.316Z",
    fill: "#1D2939"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M234.536 320.918H177.643V325.478H234.536V320.918Z",
    fill: "#136EF6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.807 335.783H177.643V340.343H207.807V335.783Z",
    fill: "#136EF6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M278.365 320.918H245.609V325.478H278.365V320.918Z",
    fill: "#136EF6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261.266 335.783H218.88V340.343H261.266V335.783Z",
    fill: "#136EF6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M295.64 196.316H160.36V203.528H295.64V196.316Z",
    fill: "#E21E5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanTicket);
export default __webpack_public_path__ + "static/media/scan-ticket.30b89289.svg";
export { ForwardRef as ReactComponent };